import { DataService } from '@api/index'
import { generateDialogParams } from '@/lib/generic.utils'
const SERVICE = new DataService('stakeholders')

export default {
  getAll(context) {
    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          context.commit('updateAll', response.data.result)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.get(params)
        .then(response => {
          context.commit('updateSingle', response.data.result)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteConfirmation(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.getDeleteConfirmation(params)
        .then(response => {
          context.commit(
            'updateGlobalDialogContent',
            generateDialogParams(params.dialogUid, 'deleteSingle', response.data),
            { root: true }
          )
          context.commit('updateGlobalDialogVisibility', { uid: params.dialogUid, value: true }, { root: true })
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.delete(params)
        .then(response => {
          context.dispatch('getAll')
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  create(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.create(params)
        .then(response => {
          if (response.data.status === 'positive') {
            resolve(response.data.result)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  update(context, params) {
    return SERVICE.update(params)
      .then(response => response.data.result)
      .catch(err => err)
  },
  getResponses(context, params) {
    const SERVICE = new DataService(`stakeholder-responses/${params.id}/subscriptions`)
    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          context.commit('updateSubscriptions', response.data.result)
          resolve(response.data.result)
        })
        .catch(err => reject(err))
    })
  },
  submitDecisions(context, params) {
    const SERVICE = new DataService(`stakeholder-responses/${params.id}/subscriptions`)
    return new Promise((resolve, reject) => {
      return SERVICE.submitDecisions(params)
        .then(response => {
          resolve(response.data.result)
        })
        .catch(err => reject(err))
    })
  }
}
